// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__26euz","colMaxWidth":"Table_colMaxWidth__2OFif"};